import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { ReplicationService } from '../replication.service';

@Component({
    selector: 'app-replication-view',
    templateUrl: './replication-view.component.html',
    standalone: false
})
export class ReplicationViewComponent implements OnInit {
  private replicationService = inject(ReplicationService);

  @Input()
  connectionMap: any;

  @Output()
  disconnectionEvent = new EventEmitter();

  ngOnInit() {}

  connectionMapKeys(): string[] {
    return Object.keys(this.connectionMap);
  }

  onDisconnect(connectionKey: string) {
    this.replicationService.disconnect(connectionKey).subscribe(() => {
      console.log('Connection disconnected: ' + connectionKey);
      this.disconnectionEvent.next(null);
    });
  }
}
